export default __webpack_public_path__ + "static/media/3_004.aa2e2618.png";